export enum SaveMode {
  individual = 1, all = 2
}

